import { render, staticRenderFns } from "./MotDePasseOublie.vue?vue&type=template&id=15c60745&scoped=true"
import script from "./MotDePasseOublie.vue?vue&type=script&lang=js"
export * from "./MotDePasseOublie.vue?vue&type=script&lang=js"
import style0 from "./MotDePasseOublie.vue?vue&type=style&index=0&id=15c60745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c60745",
  null
  
)

export default component.exports